<template>
  <main class="main" v-if="exhibition" tabindex="0">
    <div class="page-title">
      {{ exhibition.title }}
    </div>
    <gallery :images="exhibition.images" />
    <div class="page-text" v-html="exhibition.text" />
    <div class="page-text">
      <a
        v-for="file in exhibition.document"
        :key="file.url"
        :href="file.url"
        target="_blank"
      >
        {{ file.caption }}
      </a>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import Gallery from "@/components/Gallery.vue";
export default {
  name: "exhibition",
  metaInfo() {
    return {
      title: "- " + this.exhibition.title,
    };
  },
  components: {
    Gallery,
  },
  computed: mapState(["exhibition"]),
};
</script>

<style lang="scss" scoped>
@import "../assets/css/defaults.scss";

span {
  display: inline-block;
  width: calc(3 * var(--gap));
}
.page-title {
  margin-bottom: calc(var(--gap) / 6);
}

</style>
